import ServiceError from '../../core/errors/ServiceError';
import validateParamsPOC, { validServices } from '../validations/validateParamsPOC';

export default async function loadServicePOC(config) {
  try {
    validateParamsPOC(config?.poc);
  } catch (error) {
    return error;
  }

  let url = `https://widget.playoncenter.com/webservice/`;
  url += `${config.poc.service || 'video'}/${config.poc.idPub}/`;

  switch (config.poc.service) {
    case validServices.videoTag:
      url += `${config.poc.idTag}/600/338/last/${config.poc.numVideos}/${config.poc.numVideos}?json=1`;
      break;

    default:
      url += `${config.poc.idVideo}/600/338/25/0/1/0?json=1`;
  }

  const response = await fetch(url, {
    method: 'GET',
  });
  let json;
  try {
    json = await response.json();
  } catch (error) {
    if (response?.status === 204) {
      return new ServiceError('No hay contenido proporcionado por el servicio de POC', '00012');
    }
    return new ServiceError('No se ha podido cargar el servicio de POC', '00011');
  }
  return json;
}
